module.exports = __webpack_public_path__ + "static/media/iphone-mockup.8115453f.png";